import { render } from "./BookSplash.vue?vue&type=template&id=00f1dd85&scoped=true"
import script from "./BookSplash.vue?vue&type=script&lang=js"
export * from "./BookSplash.vue?vue&type=script&lang=js"

import "./BookSplash.vue?vue&type=style&index=0&id=00f1dd85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f1dd85"]])

export default __exports__